export function header() {
  let header = document.querySelector(".l-header-villa");

  // スクロール時にclassを追加
  function handleScroll() {
    if (window.scrollY > 0) {
      header.classList.add("l-header-villa--js");
    } else {
      header.classList.remove("l-header-villa--js");
    }
  }

  // イベントリスナー
  window.addEventListener("scroll", handleScroll);
}
